interface SpanIconProps {
  color?: string
  width?: number
  height?: number
  style?: React.CSSProperties
}

const SpanIcon = ({ color = "white", width = 15, height = 15, style }: SpanIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 391.67 283.22"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <rect
        fill={color}
        x="92.39"
        y="-45.85"
        width="21.71"
        height="196.15"
        transform="translate(155.47 -51.02) rotate(90)"
      />
      <rect fill={color} x="270.85" y="4.98" width="36.57" height="271.84" />
      <rect fill={color} x="84.96" y="4.98" width="36.57" height="271.84" />
      <rect
        fill={color}
        x="278.79"
        y="-45.85"
        width="21.71"
        height="196.15"
        transform="translate(341.87 -237.41) rotate(90)"
      />
      <path
        fill={color}
        d="M370.47,63.09c-15.27,34.69-45.99,58.44-81.33,58.44s-66.06-23.75-81.33-58.44h-22.73c-15.27,34.69-45.99,58.44-81.33,58.44S37.69,97.78,22.42,63.09H5.17c16.64,43.78,54.57,74.44,98.58,74.44,39.42,0,73.95-24.59,92.69-61.18,18.74,36.58,53.27,61.18,92.69,61.18,44.02,0,81.94-30.66,98.58-74.44h-17.25Z"
      />
    </svg>
  )
}

export default SpanIcon
